/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentSummaryStandardDetail {
    getFixupPrototypeFunction() { return ComplianceAssessmentSummaryStandardDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentSummaryStandardDetail>): ComplianceAssessmentSummaryStandardDetail {
        let obj = Object.assign(new ComplianceAssessmentSummaryStandardDetail(), model);
        ComplianceAssessmentSummaryStandardDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentSummaryStandardDetail>): ComplianceAssessmentSummaryStandardDetail {
        if (!model) return null;
        return ComplianceAssessmentSummaryStandardDetail.newInstance(<ComplianceAssessmentSummaryStandardDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentSummaryStandardDetail) {
        if (!obj) return;

        models.ComplianceAssessmentSummaryStandardDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentSummaryStandardDetail): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentSummaryStandardDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.policy_details) {
            for (let val of this.policy_details) {
                models.ComplianceAssessmentSummaryPolicyDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID for the compliance standard
     */
    compliance_standard_id: string;

    policy_details: Array<models.ComplianceAssessmentSummaryPolicyDetail>;

}
